import React, { useEffect, useState, useRef, useCallback } from 'react';
import WebNav from '../components/WebNav';
import Sidebar from '../components/Sidebar';
import { Dropdown, Table, Pagination, Spinner, Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CreateClub } from "../components/Modals";
import { faEllipsisV, faFilter, faDownload, faQrcode, faPowerOff, faTrash, faInfoCircle, faEdit } from "@fortawesome/free-solid-svg-icons";
import { getQRCoder } from '../services/api';
import moment from 'moment';
import axios from "axios";
import Pusher from 'pusher-js';

import jsPDF from "jspdf";
import { svg2pdf } from "svg2pdf.js";

function MyQRCode() {
  const [showFilter, setShowFilter] = useState(true);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [sort, setSort] = useState("");
  const [type, setType] = useState("");
  const [quantity, setQuantity] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCodes, setFilteredCodes] = useState([]);

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isMounted = useRef(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editQrData, setEditQrData] = useState(null);
  const handleEdit = (qr) => {
    setEditQrData(qr);
    setShowEditModal(true);
  };
  

  const [selectedQrDetails, setSelectedQrDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const handleViewMore = (qr) => {
    setSelectedQrDetails(qr);
    setShowModal(true);
  };
  const [currentUserId, setCurrentUserId] = useState(null);

  const token = localStorage.getItem('token');

  const [selectedQRs, setSelectedQRs] = useState([]);
  // Handle single checkbox selection
  const handleCheckboxChange = (id) => {
    setSelectedQRs((prevSelected) =>
      prevSelected.includes(id) ? prevSelected.filter((qrId) => qrId !== id) : [...prevSelected, id]
    );
  };

  // Handle "Select All" checkbox
  const handleSelectAll = () => {
    if (selectedQRs.length === paginatedCodes.length) {
      setSelectedQRs([]);
    } else {
      setSelectedQRs(paginatedCodes.map((qr) => qr.id));
    }
  };

  // Generate and download PDF
  const handleDownloadPDF = async () => {
    const pdf = new jsPDF();

    for (let i = 0; i < selectedQRs.length; i++) {
      const qr = paginatedCodes.find((q) => q.id === selectedQRs[i]);
      if (!qr || !qr.barcode_base64) continue;

      // Add a new page for each image (except the first one)
      if (i > 0) pdf.addPage();

      if (qr.barcode.endsWith(".svg")) {
        // Handle SVG images using svg2pdf
        const svgString = atob(qr.barcode_base64); // Decode base64 to SVG string
        const svgElement = new DOMParser().parseFromString(svgString, "image/svg+xml").documentElement;

        // Render the SVG into the PDF
        await svg2pdf(svgElement, pdf, {
          x: 50,
          y: 50,
          width: 100,
          height: 100,
        });
      } else {
        // Handle PNG images (existing code)
        pdf.addImage(
          `data:image/png;base64,${qr.barcode_base64}`, // Base64 data URL for PNG
          "PNG",
          50, // x position
          50, // y position
          100, // width
          100 // height
        );
      }
    }

    // Save the PDF
    pdf.save("Selected_QR_Codes.pdf");
  };

  useEffect(() => {
    document.body.classList.add('loged-body');

    return () => {
      document.body.classList.remove('loged-body');
    };
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      fetchData();
      isMounted.current = true;
    }

    const pusher = new Pusher('2b64ae512cb6e5abf779', {
      cluster: 'ap2',
    });
    const channel = pusher.subscribe('qr-codes');
    channel.bind('scan-count-updated', (data) => {
      console.log(data.id,currentUserId);
      if (data.id === currentUserId) {
        console.log('well-qr');
        fetchData();
      }
    });
    return () => {
      channel.unbind_all();
      pusher.unsubscribe('qr-codes');
    };

  }, [currentUserId]);

  const fetchData = async () => {
    try {
      const data = await getQRCoder();
      console.log('data',data);
      const response = data.qrlist;
      if(response[0]){
        setCurrentUserId(response[0].user_id);
      }
      setRecords(response);
      setFilteredCodes(response);
    } catch (err) {
      
      const response = [
        {
          id: 1,
          type: "Contact Page",
          image: "https://qrkey.qrkey.info/qrcodes/GN9Bwj9MzmAe.png",
          title: "QR Code 1",
          modified: "2024-11-25",
          scans: 15,
          status: 1,
        },
      ];
      setRecords(response);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = useCallback(() => {
    let updatedCodes = [...records]; // Create a copy of records to apply filters
    if (search) {
      updatedCodes = updatedCodes.filter((qr) =>
        qr.title.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (status) {
      updatedCodes = updatedCodes.filter((qr) => qr.status == status);
    }

    if (type) {
      updatedCodes = updatedCodes.filter((qr) => qr.type === type);
    }

    if (sort) {
      updatedCodes = [...updatedCodes].sort((a, b) => {
        if (sort === "name") return a.title.localeCompare(b.title);
        if (sort === "lastModified")
          return new Date(b.modified) - new Date(a.modified);
        return 0;
      });
    }

    setFilteredCodes(updatedCodes);
    setCurrentPage(1); // Reset to first page when filters change
  }, [search, status, sort, type, records]);

  useEffect(() => {
    handleFilter();
  }, [handleFilter]); // Depend on handleFilter to avoid the warning

  const totalRecords = filteredCodes.length;
  const totalPages = Math.ceil(totalRecords / quantity);
  const paginatedCodes = filteredCodes.slice(
    (currentPage - 1) * quantity,
    currentPage * quantity
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDownloadImage = (qrCodeImage) => {
    const downloadUrl = `https://qrkey.qrkey.info/download-image?image_url=${encodeURIComponent(qrCodeImage)}`;
    window.open(downloadUrl, '_blank');
  };

  const handleStatusChange = async (id, currentStatus) => {
    try {
      setLoading(true);
      const response = await axios.post('https://qrkey.qrkey.info/api/users/update-qr-status', {
        id,
        status: currentStatus === 1 ? 0 : 1,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },});
      fetchData();
      alert(response.data.message);
    } catch (error) {
      setLoading(false);
      alert('Failed to update status. Please try again.');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        setLoading(true);
        const response = await axios.delete(
          `https://qrkey.qrkey.info/api/users/delete-qr-record/${id}`, 
          {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          }
        );
        fetchData();
        alert(response.data.message);
      } catch (error) {
        setLoading(false);
        alert('Failed to delete the record. Please try again.');
      }
    }
  };

  return (
    <>
      <WebNav />
      <Sidebar />
      <div className="mt-4 user-panel-body">
        {/* Heading with Filter Button */}
        <div className="d-flex justify-content-between align-items-center">
          <h3>My Created QR Codes</h3>
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() => setShowFilter(!showFilter)}
          >
            <FontAwesomeIcon icon={faFilter} className="me-1" />
            Filter
          </button>
        </div>

        {/* Filter Section */}
        <div className={`filter-section ${showFilter ? "show" : ""}`}>
          <div className="d-flex flex-wrap gap-3">
            <div className="flex-grow-1">
              <label className="form-label">Search Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter title"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="flex-grow-1">
              <label className="form-label">QR Code Status</label>
              <select
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div className="flex-grow-1 d-none">
              <label className="form-label">Sort by</label>
              <select
                className="form-select"
                value={sort}
                onChange={(e) => setSort(e.target.value)}
              >
                <option value="">Select Sort</option>
                <option value="name">Name</option>
                <option value="lastModified">Last Modified</option>
              </select>
            </div>
            <div className="flex-grow-1">
              <label className="form-label">Type</label>
              <select
                className="form-select"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="Club Administrator">Club Administrator</option>
                <option value="Contact Page">Contact Page</option>
              </select>
            </div>
            <div className="flex-grow-1">
              <label className="form-label">Quantity</label>
              <select
                className="form-select"
                value={quantity}
                onChange={(e) => setQuantity(parseInt(e.target.value))}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>

        {/* Display selected count and download button */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>{selectedQRs.length > 0 ? `${selectedQRs.length} Record(s) Selected` : "QR Codes"}</h5>
          {selectedQRs.length > 0 && (
            <Button variant="success" onClick={handleDownloadPDF}>
              <FontAwesomeIcon icon={faDownload} className="me-2" /> Download PDF
            </Button>
          )}
        </div>

        {/* Table Section */}
        <Table bordered hover responsive className="mt-3 p-3 border rounded my-qr-table">
          <thead style={{ background: "linear-gradient(to right, #6a11cb, #2575fc)", color: "#fff" }}>
            <tr className="text-center">
              <th>
                <input type="checkbox" checked={selectedQRs.length === paginatedCodes.length} onChange={handleSelectAll} />
              </th>
              <th>Image</th>
              <th>Type</th>
              <th>Title</th>
              <th>Scans</th>
              <th>Status</th>
              {/* <th>Modified</th> */}
              <th>More</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center">
                  <div>
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-2">Loading...</p>
                  </div>
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="7" className="text-center">
                  <p className="text-danger">An error occurred while fetching the data.</p>
                </td>
              </tr>
            ) : paginatedCodes.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  <p className="text-muted">No Records Found</p>
                </td>
              </tr>
            ) : (
              paginatedCodes.map((qr) => (
                <tr key={qr.id} className="align-middle text-center">
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedQRs.includes(qr.id)}
                      onChange={() => handleCheckboxChange(qr.id)}
                    />
                  </td>
                  <td>
                    <img
                      src={'https://qrkey.qrkey.info/qrcodes/'+qr.barcode}
                      alt="QR Code"
                      className="rounded"
                      style={{ width: "50px", height: "50px", objectFit: "cover", cursor: "pointer" }}
                      onError={(e) => (e.currentTarget.src = "")}
                      onClick={() => (handleDownloadImage('https://qrkey.qrkey.info/qrcodes/'+qr.barcode))}
                    />
                  </td>
                  <td>{qr.type}</td>
                  <td>{qr.title}</td>
                  <td>{qr.scans}</td>
                  <td>{qr.status === 1 ? "Active" : "Deactivated"}</td>
                  {/* <td>{moment(qr.updated_at).format('MM/DD/YYYY HH:mm:ss')}</td> */}
                  <td>
                  <Dropdown>
                    <Dropdown.Toggle as="button" className="btn btn-sm btn-secondary border-0 p-0">
                      <FontAwesomeIcon icon={faEllipsisV} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleViewMore(qr)}>
                        <FontAwesomeIcon icon={faInfoCircle} size="sm" className="me-3" />
                        View Details
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => window.open(`https://qrkey.info/pages/${qr.slug}`, '_blank')}>
                        <FontAwesomeIcon icon={faQrcode} size="sm" className="me-3" />
                        Scan Details
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDownloadImage(`https://qrkey.qrkey.info/qrcodes/${qr.barcode}`)}>
                        <FontAwesomeIcon icon={faDownload} size="sm" className="me-3" />
                        Download
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleStatusChange(qr.id, qr.status)}>
                        <FontAwesomeIcon icon={faPowerOff} size="sm" className="me-3" />
                        {qr.status === 1 ? "Deactivate" : "Activate"}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleEdit(qr)}>
                        <FontAwesomeIcon icon={faEdit} size="sm" className="me-3" />
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(qr.id)}>
                        <FontAwesomeIcon icon={faTrash} size="sm" className="me-3" />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>

        {showEditModal && (
          <CreateClub
            closeModal={() => setShowEditModal(false)}
            editData={editQrData}
            isEditing={true}
          />
        )}

        {/* Pagination and Results */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span>
            Showing{" "}
            {totalRecords === 0
              ? "0"
              : `${(currentPage - 1) * quantity + 1}-${
                  Math.min(currentPage * quantity, totalRecords)
                }`}{" "}
            out of {totalRecords} results.
          </span>
          <Pagination>
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Previous
            </Pagination.Prev>
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index}
                active={currentPage === index + 1}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedQrDetails?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedQrDetails && (
            <div className="d-flex flex-column gap-3">
              {selectedQrDetails.identifier && (
                <div>
                  <strong>identifier:</strong>
                  <span className="ms-2">{selectedQrDetails.identifier}</span>
                </div>
              )}
              <div>
                <strong>Email:</strong>
                <span className="ms-2">{selectedQrDetails.email}</span>
              </div>
              <div>
                <strong>Last Modified:</strong>
                <span className="ms-2">{moment(selectedQrDetails.updated_at).format('MM/DD/YYYY HH:mm:ss')}</span>
              </div>
              <div>
                <strong>Messages:</strong>
                <span className="ms-2">{selectedQrDetails.messages_count ? selectedQrDetails.messages_count : '0'}</span>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MyQRCode;
